module.exports = "/images/aerial-17.jpg";